import { Typography } from '@mui/material';

import { StudentAvatar } from 'layout/MainLayout/components/Sidebar/components/components/StudentSection/components/StudentAvatar';
import { getFullName, getShortName } from 'shared/utils/user';

import { Wrapper } from './components/Wrapper';
import { GRID_AREA_SUBTITLE, GRID_AREA_TITLE } from './constants';

import type { FC, MouseEvent } from 'react';
import type { InspiredGlobalStudyPlatformApiModelsAccountStudent as Student } from 'shared/api/gsp';

export interface MenuItemProps {
  onClick: (e: MouseEvent) => void;
  student: Student;
}

export const MenuItem: FC<MenuItemProps> = ({ onClick, student }) => {
  const fullName = getFullName(student);

  return (
    <Wrapper onClick={onClick}>
      <StudentAvatar
        alt={fullName}
        src={student.profilePictureUrl ?? undefined}
      >
        {getShortName(student)}
      </StudentAvatar>
      <Typography gridArea={GRID_AREA_TITLE} noWrap>
        {fullName}
      </Typography>
      <Typography
        gridArea={GRID_AREA_SUBTITLE}
        variant="body2"
        color="text.secondary"
        noWrap
      >
        {student.formGroupName}
      </Typography>
    </Wrapper>
  );
};
